import AuthLayout from 'layout/Auth';
import Login from 'pages/mineacs/Login';
import GuestGuard from 'utils/route-guard/GuestGuard';

const LoginRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <AuthLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: <Login />
    }
  ]
};

export default LoginRoutes;
